import { TimekeeperService } from 'services/TimekeeperService';

const tk = new TimekeeperService();
const gettingPaycodeDistribution = async (setLoading, setRows) => {
    setLoading(true);

    tk.paycode_distributions
        .getPaycodeDistributions()
        .then((response) => {
            const rows = response.map((paycodeDistribution) => ({
                id: paycodeDistribution.paycodes_distribution_id,
                name: paycodeDistribution?.name,
                description: paycodeDistribution?.description,
                combination_rule: paycodeDistribution?.combination_rule?.name,
                combination_rule_id: paycodeDistribution?.combination_rule?.combination_rule_id,
            }));

            const sortedRows = rows.sort((a, b) => a.name.localeCompare(b.name));

            setRows(sortedRows);
        })
        .catch((error) => {
            console.error(error.message);
            setRows([]);
            setLoading(false);
        })
        .finally(() => {
            setLoading(false);
        });
};

const createPaycodeDistribution = async (setLoading, name, description, combination_rule_id, zones_desviations, overtimes, cross_cells, closing, reloading) => {
    setLoading(true);

    const distributions_zone_schedule_desviation = zones_desviations
        .map((zd, index) => {
            return zd.data.map((item) => ({
                zone_id: item?.zone_id ? item?.zone_id : undefined,
                schedule_desviation_rule_id: item?.schedule_desviation_rule_id ? item?.schedule_desviation_rule_id : undefined,
                row: index,
                uuid: zd.uuid,
            }));
        })
        .flat();

    const distributions_overtime_rule = overtimes
        .map((overtime, index) => {
            return overtime.data.map((item) => ({
                overtime_rule_id: item?.overtime_rule_id ? item?.overtime_rule_id : undefined,
                column: index,
                uuid: overtime.uuid,
            }));
        })
        .flat();

    const distributions_paycodes = [];

    for (const cell of cross_cells.filter((cell) => cell.paycodes.length > 0)) {
        for (const paycode of cell.paycodes) {
            distributions_paycodes.push({
                paycode_id: paycode.id,
                row: cell.row,
                column: cell.column,
                paycode_distribution_zone_schedule: cell.paycode_distribution_zone_schedule,
                paycode_distribution_overtime: cell.paycode_distribution_overtime,
            });
        }
    }

    const data = {
        name,
        description,
        combination_rule_id,
        distributions_zone_schedule_desviation,
        distributions_overtime_rule,
        distributions_paycodes,
    };

    try {
        const response = await tk.paycode_distributions.create(data);
        return response;
    } catch (error) {
        console.error(error.message);
        throw error;
    } finally {
        setLoading(false);
    }
};

const updatingPaycodeDistribution = async (setLoading, paycode_distribution_id, name, description, combination_rule_id, zones_desviations, overtimes, cross_cells, closing, reloading) => {
    setLoading(true);

    const distributions_zone_schedule_desviation = zones_desviations
        .map((zd, index) => {
            return zd.data.map((item) => ({
                zone_id: item?.zone_id ? item?.zone_id : undefined,
                schedule_desviation_rule_id: item?.schedule_desviation_rule_id ? item?.schedule_desviation_rule_id : undefined,
                row: index,
                uuid: zd.uuid,
            }));
        })
        .flat();

    const distributions_overtime_rule = overtimes
        .map((overtime, index) => {
            return overtime.data.map((item) => ({
                overtime_rule_id: item?.overtime_rule_id ? item?.overtime_rule_id : undefined,
                column: index,
                uuid: overtime.uuid,
            }));
        })
        .flat();

    const distributions_paycodes = [];

    for (const cell of cross_cells.filter((cell) => cell.paycodes.length > 0)) {
        for (const paycode of cell.paycodes) {
            distributions_paycodes.push({
                paycode_id: paycode.id,
                row: cell.row,
                column: cell.column,
                paycode_distribution_zone_schedule: cell.paycode_distribution_zone_schedule,
                paycode_distribution_overtime: cell.paycode_distribution_overtime,
            });
        }
    }

    const data = {
        name,
        description,
        combination_rule_id,
        distributions_zone_schedule_desviation,
        distributions_overtime_rule,
        distributions_paycodes,
    };

    tk.paycode_distributions
        .update(paycode_distribution_id, data)
        .then(() => {
            closing();
            reloading();
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

const deletingPaycodeDistribution = async (setLoading, paycodesDistribution, closing, reloading) => {
    setLoading(true);

    let promises = paycodesDistribution.map(async (pd) => {
        return await tk.paycode_distributions.delete(pd.id);
    });

    Promise.all(promises)
        .then((response) => {
            reloading();
            closing();
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => setLoading(false));
};

const gettingPaycodeDistributionId = async (setLoading, id, setName, setDescription, setPaycodesDistribution, showtable) => {
    setLoading(true);

    tk.paycode_distributions
        .getPaycodeDistributionById(id)
        .then((response) => {
            console.info(`response Codigos de distribución por id: ${id}`, response);
            setName(response.name);
            setDescription(response.description);
            setPaycodesDistribution(response.distributions_paycodes);
            showtable(response.combination_rule);
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

// const editPaycodeDistribution = async (setLoading, id, name, description, before_shift, after_shift, requires_approval, unplanned) => {
//     setLoading(true);
//     const data = {
//         name: name,
//         description: description,
//         before_shift: before_shift,
//         after_shift: after_shift,
//         requires_approval: requires_approval,
//         unplanned: unplanned,
//         enable: true
//     }

//     return await instance.patch(`/schedule_desviation_rules/${id}/`, data);
// }

const gettingCombinationRule = async (setLoading) => {
    setLoading(true);
    const response = await tk.combination_rule.getCombinations();
    return response;
};

// const gettingPaycodes = async (setLoading) => {
//     setLoading(true)
//     return await tk.paycodes.getPaycodes()
// }

const gettinCombination = async (setLoadingTable, selectedCombinationRule) => {
    setLoadingTable(true);
    const id = selectedCombinationRule['combination_rule_id'];

    return await tk.combination_rule.getDistributionCombination(id);
};

export {
    gettingPaycodeDistribution,
    createPaycodeDistribution,
    deletingPaycodeDistribution,
    gettingPaycodeDistributionId,
    // editPaycodeDistribution,
    gettingCombinationRule,
    // gettingPaycodes,
    gettinCombination,
    updatingPaycodeDistribution,
};
